<template>
  <div class="rate">
    <Rate
      v-model="item.value.rateAttribute.answer"
      :max="item.value.rateAttribute.score"
      :justify="justify"
    >
      <span v-for="n in Number(item.value.rateAttribute.score)" :key="n" :index="n" :value="value">
        <i
          v-if="item.value.rateAttribute.rateImageUrl.length == '0'"
          style="font-size:18px"
          class="cubeic-star"
        ></i>
        <img v-else :src="item.value.rateAttribute.rateImageUrl[0]" alt />
      </span>
    </Rate>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      // 默认值
      value: -1,
      justify: true,
    }
  },
  created: function () {
    // console.log(this.item.value.rateAttribute)
    //  this.value = this.item.value.rateAttribute.defaultValue;
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.rate .rate-item {
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-color: grey !important;
}
.rate .cube-rate-item {
  color: #d6ddef;
}
.rate .cube-rate-item.cube-rate-item_active {
  color: orange !important;
  /* background-color: orange; */
}
.rate .cube-rate li {
  /* width: 10%; */
  text-align: center;
  height: 30px;
  display: inline-block;
  margin: 0;
}
.rate .cube-rate li img {
  width: 100%;
  height: 100%;
}
.rate .cube-rate-item.cube-rate-item_active img {
  border: 2px solid rgb(66, 134, 241);
}
.rate .icon-star {
  color: #d6ddef;
}
.rate .cubeic-star {
  font-size: 18px;
}
</style>


